module.exports = __webpack_public_path__ + "img/service01.4cb7ccf7.png";